import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insuranceprofile',
  templateUrl: './insuranceprofile.component.html',
  styleUrls: ['./insuranceprofile.component.scss']
})
export class InsuranceProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
